import { render, staticRenderFns } from "./BodyConfig.vue?vue&type=template&id=25c5e405&scoped=true"
import script from "./BodyConfig.vue?vue&type=script&lang=js"
export * from "./BodyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5e405",
  null
  
)

export default component.exports